module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "customers-learning"
  }, [_c('content-switch', {
    attrs: {
      "items": _vm.switchItems,
      "selectedItem": _vm.selectedItem,
      "counts": _vm.counts
    },
    on: {
      "selectItem": function($event) {
        return _vm.handleSelectItem($event)
      }
    }
  }), _vm._v(" "), _c('claims-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'claims'),
      expression: "selectedItem === 'claims'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('claims', $event)
      }
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1a5c4ccb", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a5c4ccb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/employees/operations.vue
// module id = 791
// module chunks = 0